export default __webpack_public_path__ + "static/media/equal~zSiJKqbN.4abe1d6a.svg";